$(window).bind('load', function() {
  // Loader
  $('.loader-home')
    .delay(800)
    .fadeOut('slow');

  // Wrap first word in header title
  var $internTitle = document.querySelectorAll('.page h1.content__title, .page #content h2');
  $internTitle.forEach(function(e) {
    e.innerHTML = e.innerHTML.replace(/^([^ ]+)/, '<span class="font-weight-light">$1</span>');
  });

  $('.woocommerce__product-ancre a').each(function() {
    const anchor = $(this).attr('href');

    $(this).click(function() {
      $('html,body').animate({ scrollTop: $(anchor).offset().top - 145 }, 'slow');
    });
  });

  // Langue
  var currentLanguage = $('html').attr('lang');
  $('body').addClass('lang-' + currentLanguage);

  function changeLabelText() {
    $('.lang-fr-FR #order_review .payment_method_wc_fintecture_gateway label').text('Virement instantané');
    $('.lang-it-IT #order_review .payment_method_wc_fintecture_gateway label').text('Trasferimento istantaneo');
    $('.lang-es-ES #order_review .payment_method_wc_fintecture_gateway label').text('Transferencia instantánea');
  }
  setTimeout(changeLabelText, 2500);

  setTimeout(function() {
    var scrollPosition = $(window).scrollTop();
    $(window).scrollTop(scrollPosition + 1);
  }, 1000);
});

window.addEventListener('load', function() {
  AOS.init({
    disable: 'mobile',
    offset: 250,
    duration: 1000,
    easing: 'ease-out-back',
    once: true,
  });
});
